var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 197,
    viewBox: "0 0 449 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4850_32119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.0254,
    y: 1.42944,
    width: 320.181,
    height: 68.6101,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0254,
    y: 1.42944,
    width: 320.181,
    height: 68.6101,
    rx: 17.1525,
    fill: "url(#paint0_linear_4850_32119)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1695,
    y: 3.57351,
    width: 315.892,
    height: 64.322,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8888,
    y: 13.2933,
    width: 44.8825,
    height: 44.8825,
    rx: 8.14745,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8888,
    y: 13.2933,
    width: 44.8825,
    height: 44.8825,
    rx: 8.14745,
    stroke: "#E6E6E6",
    strokeWidth: 0.857627
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4850_32119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.472 33.2275V31.5257C102.472 30.3464 102.016 29.2697 101.271 28.4878C100.528 27.7054 99.4817 27.2112 98.3294 27.2119C97.1771 27.2112 96.1311 27.7053 95.3877 28.4878C94.6425 29.2697 94.1864 30.3463 94.1865 31.5257V33.2275C92.6263 33.2491 91.3672 34.5168 91.3672 36.0823V41.3985C91.3672 42.9772 92.6471 44.2572 94.2259 44.2572H102.433C104.012 44.2572 105.292 42.9772 105.292 41.3985V36.0823C105.292 34.5168 104.033 33.2491 102.472 33.2275ZM96.4226 29.4735C96.92 28.9533 97.5882 28.6418 98.3294 28.6411C99.0705 28.6418 99.7386 28.9533 100.236 29.4735C100.732 29.9942 101.043 30.7169 101.043 31.5257V33.2235H95.6157V31.5257C95.6158 30.717 95.9271 29.9942 96.4226 29.4735ZM103.862 41.3985C103.862 42.1866 103.221 42.8279 102.433 42.8279H94.2258C93.4377 42.8279 92.7965 42.1866 92.7965 41.3985V36.0823C92.7965 35.2941 93.4377 34.6529 94.2258 34.6529H102.433C103.221 34.6529 103.862 35.2941 103.862 36.0823V41.3985Z",
    fill: "#757676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3294 37.5845C97.691 37.5845 97.1735 38.102 97.1735 38.7403C97.1735 39.3787 97.6909 39.8963 98.3294 39.8963C98.9679 39.8963 99.4853 39.3787 99.4853 38.7403C99.4853 38.102 98.9678 37.5845 98.3294 37.5845Z",
    fill: "#757676"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.353,
    y: 21.7876,
    width: 206.304,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.353,
    y: 38.5933,
    width: 89.5155,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4850_32119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.0254,
    y: 117.95,
    width: 320.181,
    height: 68.6101,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0254,
    y: 117.95,
    width: 320.181,
    height: 68.6101,
    rx: 17.1525,
    fill: "url(#paint1_linear_4850_32119)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1695,
    y: 120.094,
    width: 315.892,
    height: 64.322,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8888,
    y: 129.814,
    width: 44.8825,
    height: 44.8825,
    rx: 8.14745,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8888,
    y: 129.814,
    width: 44.8825,
    height: 44.8825,
    rx: 8.14745,
    stroke: "#E6E6E6",
    strokeWidth: 0.857627
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4850_32119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.473 149.748V148.046C102.473 146.867 102.017 145.79 101.272 145.008C100.529 144.226 99.4826 143.732 98.3304 143.732C97.1781 143.732 96.1321 144.226 95.3887 145.008C94.6434 145.79 94.1874 146.867 94.1875 148.046V149.748C92.6273 149.769 91.3682 151.037 91.3682 152.603V157.919C91.3682 159.497 92.648 160.778 94.2269 160.778H102.434C104.013 160.778 105.293 159.497 105.293 157.919V152.603C105.293 151.037 104.033 149.769 102.473 149.748ZM96.4236 145.994C96.921 145.474 97.5892 145.162 98.3304 145.161C99.0715 145.162 99.7396 145.474 100.237 145.994C100.732 146.514 101.044 147.237 101.044 148.046V149.744H95.6167V148.046C95.6168 147.237 95.9281 146.514 96.4236 145.994ZM103.863 157.919C103.863 158.707 103.222 159.348 102.434 159.348H94.2268C93.4387 159.348 92.7974 158.707 92.7974 157.919V152.603C92.7974 151.814 93.4387 151.173 94.2268 151.173H102.434C103.222 151.173 103.863 151.814 103.863 152.603V157.919Z",
    fill: "#757676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3304 154.105C97.692 154.105 97.1745 154.622 97.1745 155.261C97.1745 155.899 97.6919 156.417 98.3304 156.417C98.9688 156.417 99.4863 155.899 99.4863 155.261C99.4863 154.622 98.9687 154.105 98.3304 154.105Z",
    fill: "#757676"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.353,
    y: 138.308,
    width: 206.304,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.353,
    y: 155.114,
    width: 89.5155,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4850_32119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.1455,
    y: 50.4016,
    width: 391.941,
    height: 83.9874,
    rx: 20.9968,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1455,
    y: 50.4016,
    width: 391.941,
    height: 83.9874,
    rx: 20.9968,
    fill: "url(#paint2_linear_4850_32119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7701,
    y: 53.0262,
    width: 386.692,
    height: 78.7382,
    rx: 18.3722,
    stroke: "white",
    strokeWidth: 5.24921
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6685,
    y: 64.9243,
    width: 54.9417,
    height: 54.9417,
    rx: 9.9735,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6685,
    y: 64.9243,
    width: 54.9417,
    height: 54.9417,
    rx: 9.9735,
    stroke: "#E6E6E6",
    strokeWidth: 1.04984
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4850_32119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.7117 89.3266H70.2104V87.2386C70.2104 84.3269 67.9355 81.9575 65.1388 81.9575C62.3422 81.9575 60.0674 84.3269 60.0674 87.2386V88.8356C60.0674 89.3187 60.4592 89.7105 60.9423 89.7105C61.4253 89.7105 61.8171 89.3187 61.8171 88.8356V87.2386C61.8171 85.2918 63.3071 83.7073 65.1389 83.7073C66.9708 83.7073 68.4608 85.2918 68.4608 87.2386V89.3266H66.6653C64.7325 89.3266 63.1658 90.893 63.1658 92.8261V99.3335C63.1658 101.266 64.7325 102.833 66.6653 102.833H76.7118C78.6446 102.833 80.2113 101.266 80.2113 99.3335V92.8261C80.2113 90.893 78.6445 89.3266 76.7117 89.3266ZM78.4614 99.3335C78.4614 100.298 77.6765 101.083 76.7117 101.083H66.6652C65.7004 101.083 64.9154 100.298 64.9154 99.3335V92.8261C64.9154 91.8613 65.7004 91.0763 66.6652 91.0763H76.7117C77.6765 91.0763 78.4614 91.8613 78.4614 92.8261V99.3335Z",
    fill: "#757676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6884 94.6647C70.907 94.6647 70.2735 95.2981 70.2735 96.0795C70.2735 96.861 70.907 97.4944 71.6884 97.4944C72.4699 97.4944 73.1034 96.861 73.1034 96.0795C73.1034 95.2981 72.47 94.6647 71.6884 94.6647Z",
    fill: "#757676"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.132,
    y: 75.3228,
    width: 252.541,
    height: 13.5733,
    rx: 6.78664,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.132,
    y: 95.895,
    width: 109.578,
    height: 13.5733,
    rx: 6.78664,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4850_32119",
    x: 58.3079,
    y: 0.0000653267,
    width: 331.616,
    height: 80.0451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_32119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_32119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4850_32119",
    x: 58.3079,
    y: 116.52,
    width: 331.616,
    height: 80.0451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_32119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_32119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4850_32119",
    x: 0.000469208,
    y: 36.3291,
    width: 448.231,
    height: 140.277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.0725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.0725
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_32119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_32119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4850_32119",
    x1: 224.116,
    y1: 70.0396,
    x2: 224.116,
    y2: 1.42944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4850_32119",
    x1: 224.116,
    y1: 186.56,
    x2: 224.116,
    y2: 117.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4850_32119",
    x1: 224.116,
    y1: 134.389,
    x2: 224.116,
    y2: 50.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4850_32119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.87,
    height: 22.87,
    fill: "white",
    transform: "translate(86.8945 24.2996)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4850_32119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.87,
    height: 22.87,
    fill: "white",
    transform: "translate(86.8955 140.82)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4850_32119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9958,
    height: 27.9958,
    fill: "white",
    transform: "translate(56.1416 78.3972)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradet);
export default __webpack_public_path__ + "static/media/upgradet.73eb1006b42893d6c1925cfc046493b7.svg";
export { ForwardRef as ReactComponent };